<template>
  <div class="modal-panel">
    <div class="modal-head">
      <h3 class="modal-title">{{ titulo }} producto</h3>
      <p class="modal-sub">Información del producto para la tienda del gimnasio</p>
    </div>

    <div class="modal-body">
      <v-form ref="form" lazy-validation class="dark-form">
        <div class="field">
          <label class="field-label">Nombre</label>
          <v-text-field
            v-model="producto.nombre"
            required
            :counter="25"
            maxlength="25"
            outlined
            dense
            hide-details="auto"
            placeholder="Ej. Proteína Whey 1kg"
            class="dark-input"
          />
        </div>

        <div class="field">
          <label class="field-label">Descripción</label>
          <v-textarea
            v-model="producto.descripcion"
            required
            outlined
            dense
            rows="3"
            hide-details="auto"
            placeholder="Describe brevemente el producto"
            class="dark-input"
          />
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field-label">Precio</label>
            <v-text-field
              v-model="producto.precio"
              type="number"
              required
              outlined
              dense
              hide-details="auto"
              prefix="$"
              placeholder="0.00"
              class="dark-input"
            />
          </div>

          <div class="field">
            <label class="field-label">Stock</label>
            <v-text-field
              v-model="producto.stock"
              type="number"
              required
              outlined
              dense
              hide-details="auto"
              placeholder="0"
              class="dark-input"
            />
          </div>
        </div>

        <div class="field">
          <label class="field-label">Categoría</label>
          <v-select
            v-model="producto.categoria"
            :items="categorias"
            required
            outlined
            dense
            hide-details="auto"
            placeholder="Selecciona una categoría"
            class="dark-input"
          />
        </div>

        <div class="field">
          <label class="field-label">Imagen del producto</label>
          <v-file-input
            v-model="producto.imagen"
            accept="image/*"
            show-size
            prepend-icon="mdi-image"
            outlined
            dense
            hide-details="auto"
            placeholder="Selecciona una imagen"
            class="dark-input"
            @change="onImagenSeleccionada"
          />
          <div v-if="imagenBase64" class="preview-wrapper">
            <img :src="imagenBase64" alt="Vista previa" class="preview-image" />
          </div>
        </div>
      </v-form>
    </div>

    <div class="modal-footer">
      <button class="btn-ghost" @click="$emit('cerrado', false)">Cancelar</button>
      <button class="btn-primary" @click="registrar">Guardar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormProducto",
  props: {
    titulo: String,
    producto: Object
  },
  data() {
    return {
      categorias: ['Equipamiento y maquinaria', 'Ropa y accesorios', 'Suplementos y nutrición', ' Limpieza e higiene', 'Productos deportivos / energetivos', 'Consumibles', 'Otros productos'],
      imagenBase64: ""
    };
  },
  methods: {
    registrar() {
      const producto = {
        ...this.producto,
        imagen: this.imagenBase64 || this.producto.imagen
      };
      this.$emit('registrar', producto);
    },
    onImagenSeleccionada(file) {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        this.imagenBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.modal-panel {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: capitalize;
}

.modal-sub {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

.modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.preview-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}

.preview-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: var(--radius);
  border: 1px solid var(--card-border);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides Vuetify (v-text-field, v-textarea, v-select, v-file-input) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> textarea,
.dark-input >>> .v-select__selection,
.dark-input >>> .v-file-input__text {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder,
.dark-input >>> textarea::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-text-field__prefix {
  color: var(--text-tertiary) !important;
  font-weight: 600 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

.dark-input >>> .v-counter {
  color: var(--text-tertiary) !important;
  font-size: 11px !important;
}

.dark-input >>> .v-chip {
  background: var(--accent-dim) !important;
  color: var(--accent) !important;
}

/* Quita las flechas del input number */
.dark-input >>> input[type="number"]::-webkit-outer-spin-button,
.dark-input >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dark-input >>> input[type="number"] {
  -moz-appearance: textfield;
}

/* Menú desplegable del v-select */
.modal-panel >>> .v-menu__content {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

.modal-panel >>> .v-list {
  background: transparent !important;
  padding: 4px !important;
}

.modal-panel >>> .v-list-item {
  border-radius: 4px !important;
  min-height: 40px !important;
}

.modal-panel >>> .v-list-item__title {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13px !important;
}

.modal-panel >>> .v-list-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.modal-panel >>> .v-list-item--active {
  background: var(--accent-dim) !important;
}

.modal-panel >>> .v-list-item--active .v-list-item__title {
  color: var(--accent) !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 480px) {
  .field-row {
    grid-template-columns: 1fr;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Productos/FormProducto.vue